import { takeLatest } from "redux-saga/effects"

import { apiGeneratorBase } from "../../Utils/saga"
import Creators, { PaymentMatchingTypes as constants } from "./reducer"
import * as services from "./services"

// Editing failures are handled by the caller rather than by the global error toast: a rename
// answers 409 with the conflict dialog's contents, and an invalid icon has to name the failing rule
// inside the popover. Both arrive through the onError callback the page passes in the payload.
const handledByCaller = { withoutErrorNotification: true }

const actions = {
  getPaymentMatchingActions: {
    request: Creators.getPaymentMatchingRequest,
    success: Creators.getPaymentMatchingSuccess,
    errors: Creators.getPaymentMatchingFailure
  },
  getPaymentMatchingSummaryActions: {
    request: Creators.getPaymentMatchingSummaryRequest,
    success: Creators.getPaymentMatchingSummarySuccess,
    errors: Creators.getPaymentMatchingSummaryFailure
  },
  getPaymentMatchingFilterOptionsActions: {
    request: Creators.getPaymentMatchingFilterOptionsRequest,
    success: Creators.getPaymentMatchingFilterOptionsSuccess,
    errors: Creators.getPaymentMatchingFilterOptionsFailure,
    // The table stays usable without its filter options, so a failure here must not raise a toast
    // on top of the one the table request would already have shown.
    withoutErrorNotification: true
  },
  getPaymentMatchingLogsActions: {
    request: Creators.getPaymentMatchingLogsRequest,
    success: Creators.getPaymentMatchingLogsSuccess,
    errors: Creators.getPaymentMatchingLogsFailure
  },
  getPaymentMatchingLogUsersActions: {
    request: Creators.getPaymentMatchingLogUsersRequest,
    success: Creators.getPaymentMatchingLogUsersSuccess,
    errors: Creators.getPaymentMatchingLogUsersFailure,
    withoutErrorNotification: true
  },
  getPaymentMatchingGroupActions: {
    request: Creators.getPaymentMatchingGroupRequest,
    success: Creators.getPaymentMatchingGroupSuccess,
    errors: Creators.getPaymentMatchingGroupFailure,
    ...handledByCaller
  },
  getPaymentMatchingIconsActions: {
    request: Creators.getPaymentMatchingIconsRequest,
    success: Creators.getPaymentMatchingIconsSuccess,
    errors: Creators.getPaymentMatchingIconsFailure,
    withoutErrorNotification: true
  },
  renamePaymentMatchingActions: {
    request: Creators.renamePaymentMatchingRequest,
    success: Creators.renamePaymentMatchingSuccess,
    errors: Creators.renamePaymentMatchingFailure,
    ...handledByCaller
  },
  setPaymentMatchingIconActions: {
    request: Creators.setPaymentMatchingIconRequest,
    success: Creators.setPaymentMatchingIconSuccess,
    errors: Creators.setPaymentMatchingIconFailure,
    ...handledByCaller
  },
  uploadPaymentMatchingIconActions: {
    request: Creators.uploadPaymentMatchingIconRequest,
    success: Creators.uploadPaymentMatchingIconSuccess,
    errors: Creators.uploadPaymentMatchingIconFailure,
    ...handledByCaller
  },
  deletePaymentMatchingIconActions: {
    request: Creators.deletePaymentMatchingIconRequest,
    success: Creators.deletePaymentMatchingIconSuccess,
    errors: Creators.deletePaymentMatchingIconFailure,
    ...handledByCaller
  }
}

const eventsOptions = {
  [constants.GET_PAYMENT_MATCHING_REQUEST]: {
    api: services.getPaymentMatching,
    actions: actions.getPaymentMatchingActions
  },
  [constants.GET_PAYMENT_MATCHING_SUMMARY_REQUEST]: {
    api: services.getPaymentMatchingSummary,
    actions: actions.getPaymentMatchingSummaryActions
  },
  [constants.GET_PAYMENT_MATCHING_FILTER_OPTIONS_REQUEST]: {
    api: services.getPaymentMatchingFilterOptions,
    actions: actions.getPaymentMatchingFilterOptionsActions
  },
  [constants.GET_PAYMENT_MATCHING_LOGS_REQUEST]: {
    api: services.getPaymentMatchingLogs,
    actions: actions.getPaymentMatchingLogsActions
  },
  [constants.GET_PAYMENT_MATCHING_LOG_USERS_REQUEST]: {
    api: services.getPaymentMatchingLogUsers,
    actions: actions.getPaymentMatchingLogUsersActions
  },
  [constants.GET_PAYMENT_MATCHING_GROUP_REQUEST]: {
    api: services.getPaymentMatchingGroup,
    actions: actions.getPaymentMatchingGroupActions
  },
  [constants.GET_PAYMENT_MATCHING_ICONS_REQUEST]: {
    api: services.getPaymentMatchingIcons,
    actions: actions.getPaymentMatchingIconsActions
  },
  [constants.RENAME_PAYMENT_MATCHING_REQUEST]: {
    api: services.renamePaymentMatching,
    actions: actions.renamePaymentMatchingActions
  },
  [constants.SET_PAYMENT_MATCHING_ICON_REQUEST]: {
    api: services.setPaymentMatchingIcon,
    actions: actions.setPaymentMatchingIconActions
  },
  [constants.UPLOAD_PAYMENT_MATCHING_ICON_REQUEST]: {
    api: services.uploadPaymentMatchingIcon,
    actions: actions.uploadPaymentMatchingIconActions
  },
  [constants.DELETE_PAYMENT_MATCHING_ICON_REQUEST]: {
    api: services.deletePaymentMatchingIcon,
    actions: actions.deletePaymentMatchingIconActions
  }
}

export default function* paymentMatchingSagas() {
  for (const type of Object.keys(eventsOptions)) {
    yield takeLatest(type, (action) => apiGeneratorBase(action, eventsOptions[type]))
  }
}
